export const fr = {
  footer: {
    cta: "Commencez à avoir un impact dans votre communauté aujourd'hui",
    copyright: "© Purposely",
    sections: {
      company: {
        title: "Entreprise",
        links: {
          about: "À propos de nous",
          privacy: "Politique de confidentialité",
          terms: "Conditions d'utilisation"
        }
      },
      product: {
        title: "Produit",
        links: {
          whatsNew: "Nouveautés",
          referral: "Programme de parrainage",
          blog: "Blog"
        }
      },
      connect: {
        title: "Connexion",
        socialAlt: {
          facebook: "Lien Facebook",
          twitter: "Lien Twitter",
          instagram: "Lien Instagram",
          linkedin: "Lien LinkedIn"
        }
      }
    },
    purpleHeartAlt: "Cœur violet de Purposely"
  }
}